import { getWithParams } from '@/services/api.service';

const actions = {
  // Wyszukanie podmiotu w GUS po NIP/REGON/KRS (params: { nip } | { regon } | { krs }).
  searchCompany(context, params) {
    return getWithParams('/gus/search', params);
  },
};

export default {
  namespaced: true,
  actions,
};
